<div class="wrapper">
	<div class="text-container">
		<ion-row>
			<ion-col>
				<h3>{{ 'reset_password.header' | translate }}</h3>
				<p class="email-msg">{{ 'reset_password.msg1' | translate }}</p>
				<!-- <p class="email-msg">{{ 'reset_password.msg2' | translate }}</p> -->
			</ion-col>
			<ion-chip (click)="dismiss()" class="cross">
				<ion-icon src="../../../assets/topgolf/close_hover.svg"></ion-icon>
			</ion-chip>
		</ion-row>
		<ion-row>
			<ion-col>
				<ion-item [class.error]="!isValidEmail" class="input" lines="none">
					<ion-input
						(ngModelChange)="resetValidation()"
						[(ngModel)]="email"
						name="email"
						placeholder="{{ 'sign_in.email' | translate }}"
						type="email"
					></ion-input>
				</ion-item>
			</ion-col>
		</ion-row>
	</div>
	<ion-row>
		<ion-col class="button-block">
			<ion-button (click)="dismiss()" class="button">
				{{ 'reset_password.cancel_btn' | translate }}
			</ion-button>
			<ion-button (click)="sendEmail()" class="button">
				{{ 'reset_password.ok_btn' | translate }}
			</ion-button>
		</ion-col>
	</ion-row>
</div>
